// initial state
import * as base from './base.js'
const baseName = '/admin/shopping'

const shoppingList = baseName + '/list'
const shoppingAdd = baseName + '/add'
const shoppingEdit = baseName + '/edit'


const obj = base.setBaseUrl('shopping', baseName)
const obj1 = base.setBaseUrl('shoppingList', shoppingList)
const obj2 = base.setBaseUrl('shoppingAdd', shoppingAdd)
const obj3 = base.setBaseUrl('shoppingEdit', shoppingEdit)


const a = Object.assign(obj, obj1, obj2, obj3,{ shoppingList, shoppingAdd,shoppingEdit})
export default a
